module.exports = __webpack_public_path__ + "img/inclusive.5a900259.svg";